module.exports = __webpack_public_path__ + "img/icontools.54877478.svg";